import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

import * as fromActions from './header.actions';
import * as fromFavoriteBtnActions from '../../../delivery-list/shared/favorite-btn/store/favorite-btn.actions';
import * as fromInboxActions from '../../../../../inbox/inbox-deliveries/store/inbox.actions';
import { HeaderMainService } from '../../header-main-view.service';

@Injectable()
export class MainHeaderEffects {
  actions$ = inject(Actions);
  headerService = inject(HeaderMainService);

  loadHeaderCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        fromActions.loadCount,
        fromFavoriteBtnActions.removeFavoriteSuccess,
        fromFavoriteBtnActions.addToFavoriteSuccess,
        fromInboxActions.refresh,
      ),
      switchMap(() => this.headerService.getCount().pipe(
        map((response: any) => {
          const favoriteCount = response.favouriteCount;
          const inboxCount = response.deliveryUnreadCount;

          return fromActions.loadCountSuccess({ favoriteCount, inboxCount });
        }),
        catchError(() => of(fromActions.loadCountFail())),
      )),
    ),
  );
}
